/* Swiper Initialiser */
const swiperContainer = document.querySelectorAll(".swiper_custom");
for (var i = 0; i < swiperContainer.length; i++) {
    swiperContainer[i].classList.add("swiper" + i);

    swiperContainer[i].querySelector(".swiper-button-prev").classList.add("prev" + i);
    swiperContainer[i].querySelector(".swiper-button-next").classList.add("next" + i);
    swiperContainer[i].querySelector(".swiper-pagination").classList.add("page" + i);

    var mySwiper = new Swiper(".swiper" + i, {
        direction: "horizontal",
        loop: true,
        slidesPerView: 1,
        centeredSlides: true,
        autoHeight: true,
        speed: 300,
        effect: "fade",
        fadeEffect: {
            crossFade: true,
        },
        navigation: {
            prevEl: ".prev" + i,
            nextEl: ".next" + i,
        },
        pagination: {
            el: ".page" + i,
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="font_13 button_rect button_clear ' + className + '">' + (index + 1) + "</span>";
            },
        },
    });
}

const swiperContainerC = document.querySelectorAll(".swiper_collection");
for (var i = 0; i < swiperContainerC.length; i++) {
    swiperContainerC[i].classList.add("swiperC" + i);

    var mySwiperC = new Swiper(".swiperC" + i, {
        direction: "horizontal",
        loop: true,
        slidesPerView: "auto",
        centeredSlides: false,
        autoHeight: true,
        speed: 300,
        mousewheel: {
            invert: false,
            forceToAxis: true
        },
    });
}

const swiperContainerP = document.querySelectorAll(".swiper_product");
for (var i = 0; i < swiperContainerP.length; i++) {
    swiperContainerP[i].classList.add("swiperP" + i);

    var mySwiperP = new Swiper(".swiperP" + i, {
        direction: "horizontal",
        loop: false,
        slidesPerView: 1,
        centeredSlides: true,
        autoHeight: true,
        speed: 300,
        effect: "fade",
        fadeEffect: {
            crossFade: true,
        },
    });

    mySwiperP.on('transitionEnd', function () {
        toggleGroup('.product-main__thumbs', '.product-main__thumb', '[data-thumb-index="' + mySwiperP.realIndex + '"]', 'active');
    });
}

function prodSlide(e) {
    mySwiperP.slideTo(e);
}


/* Header Scroll */
var prevScrollposH = window.pageYOffset;
var headerCont = document.querySelector('.site-header');

function scrollHeader() {
    var currentScrollPosH = window.pageYOffset;

    if (headerCont) {
        if (currentScrollPosH > 25) {
            headerCont.classList.add("scrolled");
        } else {
            headerCont.classList.remove("scrolled");
        }
    }

    prevScrollposH = currentScrollPosH;
}

scrollHeader();
window.onscroll = function () {
    scrollHeader();
};


/* Toggle Class (Generic) */
function toggleClass(modalName, className, toggleType, ignoreQuery) {
    if (ignoreQuery != true) {
        modalToggle = document.querySelector(modalName);
    } else {
        modalToggle = modalName;
    }

    if (modalToggle) {
        if (toggleType == "add") {
            modalToggle.classList.add(className);
        } else if (toggleType == "remove") {
            if (modalToggle.classList.contains(className)) {
                modalToggle.classList.remove(className);
            }
        } else {
            modalToggle.classList.toggle(className);
        }
    }
}

function toggleGroup(parentGroup, childClasses, targetItem, className) {
    var group = document.querySelector(parentGroup);
    var siblings = group.querySelectorAll(childClasses);
    var tItem = group.querySelector(targetItem);

    for (var i = 0; i < siblings.length; i++) {
        siblings[i].classList.remove(className);
    }

    tItem.classList.add(className);
}


/* Remove Active */
document.addEventListener('click', function (event) {
    var inputFieldtarget = document.querySelector(".account_remove_trigger.active");
    if (inputFieldtarget) {
        const inputFieldNodes = inputFieldtarget.getElementsByTagName("*");

        for (var i = 0; i < inputFieldNodes.length; i++) {
            inputFieldNodes[i].addEventListener('click', function (e) {
                e.stopPropagation();
            });

            if (event.target != inputFieldtarget) {
                inputFieldtarget.classList.remove('active');
            }
        }
    }
});


/* Klaviyo BIS */
const bisTriggers = Array.from(document.querySelectorAll('.klaviyo-bis-trigger'))

bisTriggers.map((trigger) => {
    setTimeout(() => {
        trigger.style.display = ""
    }, 400)
})


/* Set Tab Storage */
var islandCheck = document.querySelector(".site-header__island");

if (islandCheck) {
    function setLocation(location) {
        localStorage.setItem("location", location);
        localStorage.setItem("modal", "close");

        selector.classList.remove("active");

        if (location == "si") {
            setSouth();
        } else {
            setNorth();
        }
    }

    function setNorth() {
        $('[data-geo-tagged-north="os-ni"]').hide();
        $('[data-geo-tagged-north="os-ni--btn"]').text('Sold Out');
        document.body.classList.remove("si");
        document.body.classList.add("ni");
        islandCheck.value = "ni";
    }

    function setSouth() {
        $('[data-geo-tagged-south="os-si"]').hide();
        $('[data-geo-tagged-south="os-si--btn"]').text('Sold Out');
        document.body.classList.remove("ni");
        document.body.classList.add("si");
        islandCheck.value = "si";
    }

    window.addEventListener("load", (event) => {
        var loc = localStorage.getItem("location");

        if (loc == "si") {
            setSouth();
        } else {
            setNorth();
        }
    });
}